import { clearOooStatusReminderAck } from './oooStatusReminder';

export type LobbyRedirectReason =
    | 'inactivity-detected' // client: idle chain prompt timed out → lobby, status reset to available on area re-entry
    | 'ooo-inactivity' // client: manual OOO (today) prompt timed out → lobby, preserve status
    | 'status-updated' // client: manual away timeout → OOO Today set → lobby
    | 'midnight-status-update'; // client: midnight prompt timed out → OOO Today (or existing OOO kept) → lobby

const REASON_KEY = 'lobbyRedirectReason';
const PRESERVE_KEY = 'lobbyPreserveStatus';

export const setLobbyRedirect = (reason: LobbyRedirectReason, preserveStatus: boolean): void => {
    sessionStorage.setItem(REASON_KEY, reason);
    sessionStorage.setItem(PRESERVE_KEY, String(preserveStatus));
    // an automatic move to the lobby: an out-of-office status is asked about again on the next area entry
    clearOooStatusReminderAck();
};

// Called by Dashboard modal — consumes the reason key only
export const consumeLobbyRedirectReason = (): LobbyRedirectReason | null => {
    const r = sessionStorage.getItem(REASON_KEY) as LobbyRedirectReason | null;
    sessionStorage.removeItem(REASON_KEY);
    return r;
};

// Called by Main.state.tsx on area re-entry — consumes the preserve key only
export const consumeLobbyPreserveStatus = (): boolean | null => {
    const val = sessionStorage.getItem(PRESERVE_KEY);
    if (val === null) return null;
    sessionStorage.removeItem(PRESERVE_KEY);
    return val === 'true';
};
